module.exports = __webpack_public_path__ + "static/media/ipoa.21d83e9d.jpg";